var map = {
	"./ar.json": 8797,
	"./cn.json": 1931,
	"./en.json": 7960,
	"./es.json": 9353,
	"./fa.json": 3708,
	"./fr.json": 8865,
	"./hi.json": 3180,
	"./hk.json": 4746,
	"./in.json": 6618,
	"./ja.json": 5521,
	"./km.json": 3017,
	"./ko.json": 8623,
	"./ku.json": 884,
	"./pt.json": 1093,
	"./ru.json": 782,
	"./th.json": 1231,
	"./tr.json": 2067,
	"./vi.json": 1304,
	"locales/lang/ar.json": 8797,
	"locales/lang/cn.json": 1931,
	"locales/lang/en.json": 7960,
	"locales/lang/es.json": 9353,
	"locales/lang/fa.json": 3708,
	"locales/lang/fr.json": 8865,
	"locales/lang/hi.json": 3180,
	"locales/lang/hk.json": 4746,
	"locales/lang/in.json": 6618,
	"locales/lang/ja.json": 5521,
	"locales/lang/km.json": 3017,
	"locales/lang/ko.json": 8623,
	"locales/lang/ku.json": 884,
	"locales/lang/pt.json": 1093,
	"locales/lang/ru.json": 782,
	"locales/lang/th.json": 1231,
	"locales/lang/tr.json": 2067,
	"locales/lang/vi.json": 1304
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5677;